function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg190VaticanCity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.006 512.006",
    style: {
      enableBackground: "new 0 0 512.006 512.006"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.003,
    y: 0.017,
    style: {
      fill: "#FFDA44"
    },
    width: 512,
    height: 511.989
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.003,
    style: {
      fill: "#F0F0F0"
    },
    width: 256,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ACABB1"
    },
    d: "M362.259,230.125l37.455,49.55c-5.901,8.936-5.87,20.975,0.955,30.004  c8.657,11.453,24.96,13.719,36.414,5.062c11.453-8.657,13.719-24.96,5.061-36.414c-6.824-9.028-18.4-12.343-28.605-9.102  L355.165,192l-13.825,10.45l-20.738,15.676l20.902,27.649L362.259,230.125z M416.181,287.09c3.818-2.886,9.253-2.13,12.138,1.686  c2.885,3.818,2.13,9.253-1.687,12.139c-3.818,2.885-9.252,2.13-12.138-1.689C411.61,295.411,412.364,289.976,416.181,287.09z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M426.503,245.777l20.902-27.649l-20.738-15.676l-13.825-10.45l-58.375,77.225  c-10.206-3.24-21.781,0.073-28.605,9.102c-8.658,11.453-6.391,27.756,5.061,36.414c11.453,8.657,27.756,6.391,36.414-5.062  c6.825-9.028,6.856-21.069,0.955-30.004l37.455-49.55L426.503,245.777z M353.511,299.227c-2.885,3.819-8.32,4.574-12.138,1.688  c-3.818-2.886-4.572-8.321-1.687-12.139c2.886-3.817,8.32-4.573,12.138-1.686C355.641,289.976,356.396,295.411,353.511,299.227z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg190VaticanCity);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };